import * as React from "react";
import { useAdyen } from "../../../../../../../../../../../../context/Adyen/context/Adyen/context.js";
import { AdyenBrands, PaymentMethod } from "../../../../../../../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
import { CreditCardContainer } from "../../../../../../../../../../containers/Adyen/CreditCard/modules/PaymentMethodsList/containers/Adyen/CreditCard/CreditCardContainer.js";
import { AdyenPaymentType } from "../../../../../../../../../../../../models/adyen/models/adyen/payment-type.js";
const Bancontact = ({ onChange, config: paymentConfig }) => {
  const { config } = useAdyen();
  const bancontactConfig = React.useMemo(() => {
    const configData = config?.bancontactCard;
    if (configData && paymentConfig?.brands) {
      configData.brands = paymentConfig?.brands;
    }
    return configData;
  }, [config, paymentConfig]);
  const handleChange = React.useCallback(
    (state) => {
      let paymentMethodType;
      if (state.cardBrand === AdyenBrands.VISA || state.cardBrand === AdyenBrands.MAESTRO) {
        paymentMethodType = PaymentMethod.CREDITCARD;
      }
      onChange(state.data, state.isValid, paymentMethodType);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(
    CreditCardContainer,
    {
      onChange: handleChange,
      additionalOptions: bancontactConfig,
      type: AdyenPaymentType.Bancontact
    }
  );
};
export {
  Bancontact
};
//# sourceMappingURL=Bancontact.js.map
